import {
  GroupList
} from '../styled-components'

import PropTypes from 'prop-types'

const CollapsibleGroupRoot = ({
  children,
  ...props
}) => {
  return (
    <GroupList {...props}>
        {children}
    </GroupList>
  )
}

CollapsibleGroupRoot.propTypes = {
  children: PropTypes.node
}

export default CollapsibleGroupRoot
